import * as yup from "yup";
import { Schema } from "../../schema";
import { SingleValueObject } from "../base-value-object";
export class LogTimestamp extends SingleValueObject {
    timestamp;
    constructor(args) {
        super(args);
        this.timestamp = args.timestamp;
    }
    validator(args) {
        return this.validate(args, LogTimestamp.schema);
    }
    equals(t) {
        return this.timestamp.getTime() === t?.timestamp.getTime();
    }
    getValue() {
        return this.timestamp;
    }
    toString() {
        return this.timestamp.toString();
    }
    static new() {
        const now = new Date();
        return new LogTimestamp({ timestamp: now });
    }
    static schema(required = true) {
        return Schema.required({
            timestamp: yup.date().label("ログタイムスタンプ"),
        }, required);
    }
}
//# sourceMappingURL=log-timestamp.js.map